import React from "react";
import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <div className="container login-mobile-layout">
      <div className="signup-form" style={{ height: "auto", minHeight: "260px" }}>
        <h2 className="welcome">Page not found</h2>
        <p className="email-text" style={{ marginBottom: "20px" }}>
          The page you are trying to access does not exist.
        </p>
        <Link to="/home" className="create-account-button" style={{ textDecoration: "none", textAlign: "center", display: "block" }}>
          Go to Home
        </Link>
      </div>
    </div>
  );
}
